import _ from 'underscore';

export { default } from './FirstSPClientApptBookingNotification';

const FIRST_SP_CLIENT_APPT_BOOKING_NOTIFICATION = 'first_sp_client_appt_booking';

export const getFirstSPApptFromNotifications = notifications => {
  const smartPricedAppt = _.find(
    notifications,
    notification => notification.type === FIRST_SP_CLIENT_APPT_BOOKING_NOTIFICATION,
  );
  return smartPricedAppt;
};
